import type { GridInitialState } from '@packages/fenrir/components/datagrid';

import type { AssetType } from '../../assets/asset-type';

import { ASSETS_DATA_GRID_STATE_KEY } from './asset-table.constants';

export const updateGridStateToSession = (
  newState: GridInitialState,
  assetType: AssetType,
) => {
  try {
    sessionStorage.setItem(
      ASSETS_DATA_GRID_STATE_KEY,
      JSON.stringify({ [assetType]: newState }),
    );
  } catch {
    // Do not do anything if session storage fails
    // This is a fallback in case the session storage is not available
  }
};
